/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_Rotate_Cover_LetterInputs */

const en_landing_hero_rotate_cover_letter = /** @type {(inputs: Landing_Hero_Rotate_Cover_LetterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cover letter`)
};

const de_landing_hero_rotate_cover_letter = /** @type {(inputs: Landing_Hero_Rotate_Cover_LetterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anschreiben`)
};

const fr_landing_hero_rotate_cover_letter = /** @type {(inputs: Landing_Hero_Rotate_Cover_LetterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lettre de motivation`)
};

const es_landing_hero_rotate_cover_letter = /** @type {(inputs: Landing_Hero_Rotate_Cover_LetterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`carta de empleo`)
};

const it_landing_hero_rotate_cover_letter = /** @type {(inputs: Landing_Hero_Rotate_Cover_LetterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lettera di lavoro`)
};

const nl_landing_hero_rotate_cover_letter = /** @type {(inputs: Landing_Hero_Rotate_Cover_LetterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`motivatiebrief`)
};

const pl_landing_hero_rotate_cover_letter = /** @type {(inputs: Landing_Hero_Rotate_Cover_LetterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`list motywacyjny`)
};

const fi_landing_hero_rotate_cover_letter = /** @type {(inputs: Landing_Hero_Rotate_Cover_LetterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`saatekirjeesi`)
};

const da_landing_hero_rotate_cover_letter = /** @type {(inputs: Landing_Hero_Rotate_Cover_LetterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ansøgningsbrev`)
};

const sv_landing_hero_rotate_cover_letter = /** @type {(inputs: Landing_Hero_Rotate_Cover_LetterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`personliga brev`)
};

/**
* | output |
* | --- |
* | "cover letter" |
*
* @param {Landing_Hero_Rotate_Cover_LetterInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_hero_rotate_cover_letter = /** @type {((inputs?: Landing_Hero_Rotate_Cover_LetterInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_Rotate_Cover_LetterInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_hero_rotate_cover_letter(inputs)
	if (locale === "fr") return fr_landing_hero_rotate_cover_letter(inputs)
	if (locale === "es") return es_landing_hero_rotate_cover_letter(inputs)
	if (locale === "it") return it_landing_hero_rotate_cover_letter(inputs)
	if (locale === "nl") return nl_landing_hero_rotate_cover_letter(inputs)
	if (locale === "pl") return pl_landing_hero_rotate_cover_letter(inputs)
	if (locale === "fi") return fi_landing_hero_rotate_cover_letter(inputs)
	if (locale === "da") return da_landing_hero_rotate_cover_letter(inputs)
	if (locale === "sv") return sv_landing_hero_rotate_cover_letter(inputs)
	return en_landing_hero_rotate_cover_letter(inputs)
});